import { useInterval } from "./useInterval";

const getRandomDirection = () => {
    const x = Math.random() * 2 - 1;
    const y = Math.random() * 2 - 1;
    const sum = Math.sqrt(x * x + y * y);

    return {
        x: x / sum,
        y: y / sum,
    }
}

const getRandomPosition = () => {
    const x = window.innerWidth * Math.random();
    const y = window.innerHeight * Math.random();

    return { x, y };
}

const isPositionBlocked = (x, y, blocks) => {
    return blocks.some(block => {
        const rect = block.getBoundingClientRect();
        const top = window.innerHeight - rect.top;
        const bottom = window.innerHeight - rect.bottom;
        const left = rect.left;
        const right = rect.right;

        return (x >= left && x <= right && y <= top && y >= bottom);
    })
}

export const getRandomlyMovingSource = (state, blocks, hexagonBlocks) => {
    const isSmallScreen = window.innerWidth < 768;
    let { x, y } = getRandomPosition();

    let maxAttempts = 20;
    while (isPositionBlocked(x, y, blocks) && maxAttempts > 0) {
        ({ x, y } = getRandomPosition());
        maxAttempts--;
    }

    if (maxAttempts === 0) {
        return null;
    }

    const colorVariation = 0.3;
    const intensityVariation = isSmallScreen ? 8 : 20;
    const intensity = 15 + Math.random() * intensityVariation;
    const lightSource = {
        isVisible: true,
        position: {
            x,
            y,
        },
        targetPosition: {
            x,
            y,
        },
        intensity: 0,
        color: {
            r: 1 - Math.random() * colorVariation,
            g: 1 - Math.random() * colorVariation,
            b: 1 - Math.random() * colorVariation,
        },
    }
    
    let direction = getRandomDirection();
    const speed = 0.8;
    useInterval(() => {
        if (state.isPaused) {
            return;
        }

        if (lightSource.intensity < intensity) {
            lightSource.intensity += 0.1;
        }

        let nextX = lightSource.position.x + direction.x * speed;
        let nextY = lightSource.position.y + direction.y * speed;

        const revertX = () => {
            direction.x = -direction.x;
            nextX = lightSource.position.x + direction.x * 1;
        }

        const revertY = () => {
            direction.y = -direction.y;
            nextY = lightSource.position.y + direction.y * 1;
        }

        if (nextX < 0 || nextX > window.innerWidth) {
            revertX();
        }
        if (nextY < 0 || nextY > window.innerHeight) {
            revertY();
        }

        for (let b = 0; b < blocks.length; b++) {
            const block = blocks[b];
            const rect = block.getBoundingClientRect();
            const top = window.innerHeight - rect.top;
            const bottom = window.innerHeight - rect.bottom;
            const left = rect.left;
            const right = rect.right;

            if (nextX >= left && nextX <= right && nextY <= top && nextY >= bottom) {
                const yDiff = Math.min(Math.abs(nextY - top), Math.abs(nextY - bottom));
                const xDiff = Math.min(Math.abs(nextX - left), Math.abs(nextX - right));

                if (yDiff < xDiff) {
                    revertY();
                } else {
                    revertX();
                }
            }
        }

        const hexSteerStrength = 0.055;
        for (let h = 0; h < hexagonBlocks.length; h++) {
            const hexBlock = hexagonBlocks[h];
            const rect = hexBlock.getBoundingClientRect();
            const centerX = (rect.left + rect.right) / 2;
            const centerY = window.innerHeight - (rect.top + rect.bottom) / 2;
            const influenceRadius = Math.max(rect.width, rect.height);
            const rdx = nextX - centerX;
            const rdy = nextY - centerY;
            const dist = Math.hypot(rdx, rdy);
            if (dist >= influenceRadius) {
                continue;
            }
            if (dist < 1e-6) {
                continue;
            }
            const ux = rdx / dist;
            const uy = rdy / dist;
            const mx = direction.x * (1 - hexSteerStrength) + ux * hexSteerStrength;
            const my = direction.y * (1 - hexSteerStrength) + uy * hexSteerStrength;
            const mlen = Math.hypot(mx, my);
            if (mlen < 1e-6) {
                continue;
            }
            direction.x = mx / mlen;
            direction.y = my / mlen;
            nextX = lightSource.position.x + direction.x * speed;
            nextY = lightSource.position.y + direction.y * speed;
        }

        lightSource.position.x = nextX;
        lightSource.position.y = nextY;
        lightSource.targetPosition.x = nextX;
        lightSource.targetPosition.y = nextY;
    })

    return lightSource;
}